export default __webpack_public_path__ + "static/media/badges-icon.9332caf3.svg";